import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  card: {
    padding: '10px 25px',
    backgroundColor: theme.palette.grey[100],
    borderRadius: 8
  },
  label: {
    color: theme.palette.grey[500],
    fontSize: 12,
    fontWeight: 500
  },
  value: {
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.grey[700]
  },
  red: {
    color: theme.palette.error.main
  },
  green: {
    color: theme.palette.secondary.main
  },
  currencyDisplay: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: theme.spacing(2),
    position: 'relative',
    color: theme.palette.grey[500],
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 10,
      bottom: 10,
      width: 2,
      backgroundColor: theme.palette.grey[500]
    }
  }
}))
